import { motion, useInView } from "framer-motion";
import AboutHomeSection from "./AboutHomeSection";
import WhyChooseUsSection from "./WhyChooseUs";
import React, { useRef } from "react";
import AboutMainImg from '../Img/About_Home_Img.png'
import AboutHomeClouds from '../Img/About_Home_clouds.png'

const subheading = "About Us";
const heading = "Trusted Manpower Solutions";

const paragraph =
  "At V9 Prime Force Pvt. Ltd., we specialize in delivering complete HR and recruitment solutions tailored to the evolving needs of modern businesses. As a trusted partner to companies across industries, we bring expertise, speed, and integrity to every aspect of human resource management.";

const paragraph2 =
  "We are a dynamic HR services company dedicated to helping organizations attract, manage, and retain top talent. With a client-focused approach and a strong network of professionals, we bridge the gap between skilled candidates and growing businesses.";

const paragraph3 =
  "With over 7 years of experience, our team of seasoned recruiters brings deep industry knowledge and a keen understanding of market trends. We rigorously screen and select candidates to ensure not only skill alignment but also cultural fit within your organization.";

const paragraph4 =
  "Empowering your business through people—our mission is to build the future of work, together. Whether you need executive search, temporary staffing, or end-to-end HR solutions, V9 Prime Force is your reliable partner in workforce transformation.";


const splitWords = (text) => text.split(" ").map((word, i) => ({ word, key: i }));

const About = () => {
    const textRef = useRef(null);
    const isInView = useInView(textRef, { once: true, margin: "-100px" });

    return (
        <>
            {/* About Section */}
            <div className="other-pages-main-section-v9">
                <motion.h2
                    className="enquiry-heading"
                    initial={{ opacity: 0, y: 20 }}
                    animate={{ opacity: 1, y: 0 }}
                    transition={{ duration: 0.8 }}
                >
                    About Us
                </motion.h2>

                <motion.p
                    className="enquiry-subheading"
                    initial={{ opacity: 0, y: 20 }}
                    animate={{ opacity: 1, y: 0 }}
                    transition={{ duration: 0.8, delay: 0.2 }}
                >
                    We are dedicated to providing exceptional solutions that are tailored to meet
                    your unique needs.
                </motion.p>
            </div>
            <div className="about-home-main-v9">
                <div className="about-home-wrapper-v9">
                    <motion.div
                        className="about-home-text-v9"
                        ref={textRef}
                        initial="hidden"
                        animate={isInView ? "visible" : "hidden"}
                        variants={{
                            visible: {
                                transition: {
                                    staggerChildren: 0.06,
                                },
                            },
                        }}
                    >
                        {/* Subheading */}
                        <motion.p className="about-home-subheading-v9">
                            {splitWords(subheading).map(({ word, key }) => (
                                <motion.span
                                    key={`sub-${key}`}
                                    className="about-home-heading-word-v9"
                                    variants={{
                                        hidden: { opacity: 0, y: 15 },
                                        visible: { opacity: 1, y: 0 },
                                    }}
                                >
                                    {word}&nbsp;
                                </motion.span>
                            ))}
                        </motion.p>

                        {/* Heading */}
                        <motion.h2 className="about-home-heading-v9">
                            {splitWords(heading).map(({ word, key }) => (
                                <motion.span
                                    key={`head-${key}`}
                                    className="about-home-heading-word-v9"
                                    variants={{
                                        hidden: { opacity: 0, y: 20 },
                                        visible: { opacity: 1, y: 0 },
                                    }}
                                >
                                    {word}&nbsp;
                                </motion.span>
                            ))}
                        </motion.h2>

                        {/* Paragraph 1 */}
                        <motion.p className="about-home-paragraph-v9">
                            {splitWords(paragraph).map(({ word, key }) => (
                                <motion.span
                                    key={`para1-${key}`}
                                    className="about-home-heading-word-v9"
                                    variants={{
                                        hidden: { opacity: 0, y: 20 },
                                        visible: { opacity: 1, y: 0 },
                                    }}
                                >
                                    {word}&nbsp;
                                </motion.span>
                            ))}
                        </motion.p>

                        {/* Paragraph 2 */}
                        <motion.p className="about-home-paragraph-v9">
                            {splitWords(paragraph2).map(({ word, key }) => (
                                <motion.span
                                    key={`para2-${key}`}
                                    className="about-home-heading-word-v9"
                                    variants={{
                                        hidden: { opacity: 0, y: 20 },
                                        visible: { opacity: 1, y: 0 },
                                    }}
                                >
                                    {word}&nbsp;
                                </motion.span>
                            ))}
                        </motion.p>

                        <motion.p className="about-home-paragraph-v9">
                            {splitWords(paragraph3).map(({ word, key }) => (
                                <motion.span
                                    key={`para3-${key}`}
                                    className="about-home-heading-word-v9"
                                    variants={{
                                        hidden: { opacity: 0, y: 20 },
                                        visible: { opacity: 1, y: 0 },
                                    }}
                                >
                                    {word}&nbsp;
                                </motion.span>
                            ))}
                        </motion.p>

                        <motion.p className="about-home-paragraph-v9">
                            {splitWords(paragraph4).map(({ word, key }) => (
                                <motion.span
                                    key={`para4-${key}`}
                                    className="about-home-heading-word-v9"
                                    variants={{
                                        hidden: { opacity: 0, y: 20 },
                                        visible: { opacity: 1, y: 0 },
                                    }}
                                >
                                    {word}&nbsp;
                                </motion.span>
                            ))}
                        </motion.p>
                    </motion.div>

                    {/* Image Column */}
                    <motion.div
                        className="about-home-image-v9"
                        initial={{ opacity: 0, scale: 0.95 }}
                        animate={isInView ? { opacity: 1, scale: 1 } : {}}
                        transition={{ duration: 0.8, ease: "easeOut" }}
                    >
                        <img
                            src={AboutMainImg}
                            alt="V9 Primeforce team at work"
                            className="about-home-img-v9"
                        />
                    </motion.div>
                </div>
                <img src={AboutHomeClouds} alt="" className="about-home-clouds-v9" />
            </div>
            <WhyChooseUsSection />
        </>
    );
};

export default About;
